import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Stack } from '@chakra-ui/react';
import { useGenerateForgotPasswordToken, useNewPassword } from 'hooks';
import { useTranslation } from 'localization';
import { routes } from 'statics';

import {
  AuthSuggestion,
  DesktopAuthHeader,
  SERVICE_CARD_BORDER_RADIUS,
} from 'components';

import { Form } from './components';

const NewPassword: React.FC = () => {
  const { t } = useTranslation('component.auth.newPassword');
  const [csrfToken, setCsrfToken] = React.useState<string>('');

  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const { mutateAsync: sendForgotPasswordCode, isPending: csrfLoading } =
    useGenerateForgotPasswordToken();

  const { mutateAsync: submit, isPending: isSubmitting } =
    useNewPassword(csrfToken);

  const token = searchParams.get('token') || '';
  const email = searchParams.get('email') || '';

  React.useEffect(() => {
    if (token) {
      sendForgotPasswordCode({
        code: token,
        email: email,
      })
        .then((res) => {
          if (res?.token) {
            setSearchParams({ email: email });
            setCsrfToken(res.token);
          }
        })
        .catch(() => {
          navigate(routes.auth.forgotPassword.url);
        });
    } else {
      navigate(routes.auth.forgotPassword.url);
    }
  }, []);

  return (
    <Stack w="100%" align="stretch" gap={{ base: 6, md: 8 }}>
      <DesktopAuthHeader title={t('newPassword')} titleAlign="center" />
      <Box
        bg="dark"
        borderWidth="1px"
        borderColor="rgba(255,255,255,0.08)"
        borderRadius={SERVICE_CARD_BORDER_RADIUS}
        px={{ base: 5, md: 7 }}
        py={{ base: 6, md: 8 }}
        w="100%"
      >
        <Form
          csrfLoading={csrfLoading}
          isSubmitting={isSubmitting}
          onButton={(data) =>
            submit({ ...data, username: searchParams.get('email') || '' }).then(
              () => {
                navigate(routes.auth.signIn.url);
              }
            )
          }
        />
      </Box>
      <AuthSuggestion include={['sign-in', 'sign-up']} />
    </Stack>
  );
};

export default NewPassword;
